export const generalConstants = {
  UPDATE_TAX_RATES_SUCCESS: 'UPDATE_TAX_RATES_SUCCESS',
  UPDATE_ATTRIBUTES_SUCCESS: 'UPDATE_ATTRIBUTES_SUCCESS',
  UPDATE_PRICING_CATEGORIES_SUCCESS: 'UPDATE_PRICING_CATEGORIES_SUCCESS',

  GET_ENTITY_STRUCTURE_STARTED: 'GET_ENTITY_STRUCTURE_STARTED',
  GET_ENTITY_STRUCTURE_SUCCESS: 'GET_ENTITY_STRUCTURE_SUCCESS',
  GET_ENTITY_STRUCTURE_FAILURE: 'GET_ENTITY_STRUCTURE_FAILURE',
};
